import React from "react";
import { ForgotPassword } from "../containers";

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
